import { createReducer, on, Action } from '@ngrx/store';
import * as fromModels from '@models';
import * as viewActions from '@view/store/view.actions';

export const viewFeatureKey = 'view';

export enum errorTypes {
  fetching = 'fetching',
  creating = 'creating',
  editing = 'editing',
  deleting = 'deleting',
}

export interface ViewState {
  collection: fromModels.View[];
  row: fromModels.View;
  error: Error;
  errorType: errorTypes;

  isFetching: boolean;
  hasError: boolean;
  successfullyAdded: boolean;
  successfullyEdited: boolean;
  successfullyDeleted: boolean;
  successfullyApplied: boolean;
}

export const initialState: ViewState = {
  collection: [],
  row: null,
  error: null,
  errorType: null,

  isFetching: false,
  hasError: false,
  successfullyAdded: false,
  successfullyEdited: false,
  successfullyDeleted: false,
  successfullyApplied: false,
};

const viewReducer = createReducer(
  initialState,

  // inicia la carga de los datos
  on(
    viewActions.changeDefaultViewStatus,
    (state, payload) => {
    return Object.assign({}, state, {
      isFetching: true,
      successfullyApplied: false,
    });
  }),

  // retorna los datos cargados
  on(viewActions.defaultViewStatusChanged, (state, payload) => {
    return Object.assign({}, state, {
      row: payload.row,
      isFetching: false,
      successfullyApplied: true,
    });
  }),

  // ocurrio un error
  on(viewActions.failRequest, (state, payload) => (
    Object.assign({}, state, {
      hasError: true,
      row: null,
      error: payload.error,
      errorType: payload.errorType,
    })
  )),
);

export function reducer(state: ViewState | undefined, action: Action) {
  return viewReducer(state, action);
}
